var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"modal__setupchannel3",attrs:{"visible":_vm.visible3,"footer":null,"closable":true},on:{"cancel":_vm.handleCancel}},[[(_vm.modalContent.Delete)?_c('Delete',{attrs:{"channel-clicked":_vm.channelClicked},on:{"handleCancel":_vm.handleCancel}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }